const texts = {
  imageLabel: 'Recipe Image',
  uploadImage: 'Upload Image',
};

export default texts;
